// The sprite build's closed grammar, measured across the full master sprite
// (6,033 symbols): two elements, seven attributes. Compared lowercase.
const ALLOWED_ELEMENTS = new Set(['symbol', 'path']);
const ALLOWED_ATTRIBUTES = new Set([
    'id',
    'viewbox',
    'fill',
    'stroke',
    'stroke-linecap',
    'stroke-linejoin',
    'd',
]);
/**
 * Structurally validates fetched symbol markup against the sprite grammar:
 * exactly one `<symbol>` whose id matches the payload id, containing only
 * allowlisted elements and attributes.
 *
 * The shell is parsed in HTML mode so the fragment parse below runs the same
 * algorithm, with the same SVG context, as React's innerHTML commit — this
 * validates the exact tree that will be injected. DOMParser documents are
 * inert (no script evaluation, no resource fetches), so hostile payloads
 * can't execute during validation the way they could on a detached
 * live-document element (e.g. `<img onerror>`).
 */
export function validateSymbolMarkup(icon) {
    const inertHost = new DOMParser()
        .parseFromString('<svg><g></g></svg>', 'text/html')
        .querySelector('svg > g');
    if (!inertHost) {
        return false;
    }
    inertHost.innerHTML = icon.symbol;
    if ((inertHost.textContent ?? '').trim() !== '') {
        return false;
    }
    const symbolRoot = inertHost.firstElementChild;
    if (inertHost.childElementCount !== 1 || symbolRoot?.localName.toLowerCase() !== 'symbol') {
        return false;
    }
    if (symbolRoot.getAttribute('id') !== icon.id) {
        return false;
    }
    for (const element of [symbolRoot, ...symbolRoot.querySelectorAll('*')]) {
        if (!ALLOWED_ELEMENTS.has(element.localName.toLowerCase())) {
            return false;
        }
        for (const attribute of Array.from(element.attributes)) {
            if (!ALLOWED_ATTRIBUTES.has(attribute.name.toLowerCase())) {
                return false;
            }
        }
    }
    return true;
}
//# sourceMappingURL=validateSymbolMarkup.js.map